import { PublicKey } from "@solana/web3.js";
import { makeDSTProgram } from "./makeDSTProgram.js";

export function acceptOperator({
  dst,
  pendingOperator,
}: {
  dst: PublicKey;
  pendingOperator: PublicKey;
}) {
  const program = makeDSTProgram();
  const result = program.methods.acceptOperator().accountsPartial({
    dst,
    pendingOperator,
  });

  return result;
}
